import { AlertIcon, CompletedCheckmarkIcon,colors } from "@commonsku/styles";
import { PS_TO_CS_STATUS_MAP } from "../constants/PsToCsStatusMap";


export function PSIcon({ status_name }) {
  const statusColor =  PS_TO_CS_STATUS_MAP[status_name] ? PS_TO_CS_STATUS_MAP[status_name].color : '';
    if (statusColor === colors.secondary3['70']) {
      return <CompletedCheckmarkIcon color={statusColor}/>;
    }
    return <AlertIcon color={statusColor}/>;
}